// extracted by mini-css-extract-plugin
export default {"book-column-header":"bookColumnHeader_book-column-header__bGXVB"};